import { Link } from 'react-router-dom'
import { ArticleTag } from '../HomePage/ArticleTag'
import { isAdminOrEditor } from '../../services/permission.service'
import { formatHebrewDate } from '../../services/util.service'
import { PostAuthorLine } from './PostAuthorLine'
import { useSelector } from 'react-redux'

export function PostPreview({ post, onRemovePost, author }) {
  const loggedInUser = useSelector((state) => state.userModule.loggedInUser)

  return (
    <div>
      <div className="mt-2">
        <div className="grid grid-cols-1 gap-4">
          <div key={post._id} className="mt-5 relative">
            <Link to={`/post/${post._id}`}>
              {post.imageUrl && (
                <img
                  src={post.imageUrl}
                  alt={post.title}
                  className="w-full h-[220px] lg: object-cover mb-4"
                />
              )}
              <div className="absolute -translate-y-[90%] right-4">
                <ArticleTag tags={post.tags} />
              </div>
            </Link>
            <h3 className="text-xl text-white mt-8 max-w-[320px]">
              <Link to={`/post/${post._id}`}>{post.title}</Link>
            </h3>
    <PostAuthorLine userId={post.author?.userId} createdAt={post.createdAt} />
          </div>
          {isAdminOrEditor(loggedInUser) && (
            <button
              className="ml-4 bg-red-500 text-white py-1 px-2 rounded"
              onClick={() => onRemovePost(post._id)}
            >
              הסר פוסט
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
